import { render } from "./AddTestimoni.vue?vue&type=template&id=6bc14e09"
import script from "./AddTestimoni.vue?vue&type=script&lang=js"
export * from "./AddTestimoni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__